import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {
  MobileRadioContainer,
  MobileLabel,
  ButtonGroup,
  RadioButtonLight,
  RadioButtonDark
} from './styles';

const MobileRadioButtons = ({
  mobileLabel,
  name,
  relatedTo,
  options,
  onChange
}) => {
  const selected = useSelector(s => s.listFilter?.[relatedTo]?.[name]?.value, shallowEqual) ?? {};
  const defaultValue = options.find(o => o.data.default)?.data?.value ?? options?.[0]?.data?.value;
  const val = selected?.[0]?.data?.value || defaultValue;
  const [value, setValue] = useState(val);

  const handleChange = (e, newValue) => {
    setValue(newValue);
    onChange(options.filter(o => o.data.value === newValue));
  };

  return (
    <MobileRadioContainer>
      <MobileLabel
        fontWeight={500}
        color="textSecondary"
      >
        {mobileLabel}
      </MobileLabel>
      <ButtonGroup>
        {options.map((option, index) => {
          const { label: buttonLabel, data: optionData } = option;
          const optionValue = optionData.value;

          let borderRadius = '0';
          if (index === 0) borderRadius = '8px 0 0 8px'; // First button
          if (index === options.length - 1) borderRadius = '0 8px 8px 0'; // Last button

          const isSelected = value === optionValue;
          const ButtonComponent = isSelected ? RadioButtonLight : RadioButtonDark;

          return (
            <ButtonComponent
              key={`${buttonLabel}_${optionValue}`}
              type="button"
              variant="contained"
              onClick={() => handleChange(null, optionValue)}
              style={{ borderRadius }}
              color={isSelected ? 'secondary' : 'inherit'}
            >
              {buttonLabel}
            </ButtonComponent>
          );
        })}
      </ButtonGroup>
    </MobileRadioContainer>
  );
};

export default MobileRadioButtons;
